import * as React from "react";

function SvgWave2Inverted(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 200" {...props}><path d="M1432.2 156.2c-88.8 16.7-156 5.3-204-8.5s-147.1-62.2-223.1-73.9c-75.4-11.6-164 7.5-275 27.9S571 135.5 456 125.5c-119.7-10.4-224.7-52-294.4-73C67.1 24-10 55.5-10 55.5v155.2h1620V132c-53-10-86.8 7.1-177.8 24.2z" /></svg>;
}

export default SvgWave2Inverted;